import useSWR  from "swr";
import useSWRInfinite, { SWRInfiniteConfiguration } from "swr/infinite";
import api from "./api";

const fetcher = (url: string) => api.get(url).then((res) => res.data);

export const swrGlobalConfig = {
  fetcher,
  revalidateOnFocus: false,
  dedupingInterval: 5000,
};

export const useFetchSWR = (url: string | null, options?: any) => {
  return useSWR(url, fetcher, { ...swrGlobalConfig, ...options });
};

export const useFetchSWRInfinite = (
  getKey: (pageIndex: number, previousPageData: any) => string | null,
  options?: SWRInfiniteConfiguration
) => {
  return useSWRInfinite(getKey, fetcher, { ...swrGlobalConfig, ...options });
};
